var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav navbar-nav",attrs:{"id":"main-menu-navigation"}},_vm._l((_vm.items),function(item,index){return _c(_vm.resolveNavComponent(item),{key:((item.subject) + "-" + index)
    || ((item.header) + "-" + index)
    || ((item.title) + "-" + index),tag:"component",attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }